import { ListItem, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface IAccordionSegmentListItem {
  number: number;
  text: string;
}

export const Step = ({ number, text }: IAccordionSegmentListItem) => {
  const isDesktop = useIsDesktop();
  return (
    <ListItem
      sx={{
        gap: isDesktop ? '20px' : '15px',
        p: 0,
        alignItems: 'center',
      }}
    >
      <div
        style={{
          padding: isDesktop ? '5px 0 ' : '8px 0',
          backgroundColor: 'white',
        }}
      >
        <div
          style={{
            height: '28px',
            aspectRatio: '1',
            borderRadius: '50%',
            border: '1px solid #1752AF',
            textAlign: 'center',
            color: '#1752AF',
            fontSize: '1rem',
            fontWeight: 400,
            backgroundColor: 'white',
          }}
        >
          {number}
        </div>
      </div>
      <Typography
        fontSize={isDesktop ? '1.125rem' : '1rem'}
        fontWeight='400'
        lineHeight='1.375rem'
        color='#39556B'
      >
        {text}
      </Typography>
    </ListItem>
  );
};
